// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeOauthAppleVerifyBody = {
  idToken: string;
};

export type typeOauthAppleVerifyOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    accessToken: string;
    refreshToken: string;
    expiresInSeconds: number;
    user: { userId: string; email?: string | null; isSuperAdmin: boolean };
  };
};

export type typeOauthAppleVerifyOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthAppleVerifyOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthAppleVerifyOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaOauthAppleVerifyBody = {
  type: "object",
  properties: { idToken: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["idToken"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createOauthAppleVerify(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaOauthAppleVerifyBody);
  }

  return async function postOauthAppleVerify(
    payload: typeOauthAppleVerifyBody,
  ): Promise<typeOauthAppleVerifyOutput200 | typeOauthAppleVerifyOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postOauthAppleVerify" failed before calling the network. #213edd4b861c`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#213edd4b861c" },
        },
        data: null,
      } as typeOauthAppleVerifyOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/oauth/apple-verify`,
      httpMethod: "POST",
      options,
    })) as typeOauthAppleVerifyOutput200 | typeOauthAppleVerifyOutput400;
  };
}
